(function() {

  const main = document.querySelector('main');
  const sidebar = document.querySelector('[data-section-type="sidebar"]');
  const resources = document.querySelector('[data-section-type="resources"]');

  var minHeight;

  if (sidebar && resources) { 
    minHeight = Math.max(sidebar.offsetHeight, resources.offsetHeight);
  } else if (sidebar) {
    minHeight = sidebar.offsetHeight;
  } else if (resources) {
    minHeight = resources.offsetHeight;
  }

  if (!minHeight) return; 
  main.style.minHeight = minHeight + 'px';
})();